"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "h-full flex items-center justify-start cursor-pointer w-full" };
const _hoisted_2 = {
    key: 0,
    class: "flex grow flex-col items-start justify-center content-center overflow-hidden mr-4"
};
const _hoisted_3 = {
    key: 2,
    class: "marso-icon-chevron-down transform-gpu transition-transform text-xs",
    "aria-hidden": "true"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 2,
    class: "p-2 text-gray-500 text-sm"
};
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DropdownMenu',
    props: {
        buttonText: {
            type: String,
            default: "",
        },
        right: {
            type: Boolean,
            default: false,
        },
        hideCaret: {
            type: Boolean,
            default: false,
        },
        mobileFullWidth: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        searchable: { type: Boolean, default: false },
    },
    emits: ["selected"],
    setup(__props, { expose: __expose, emit }) {
        const props = __props;
        const searchQuery = (0, vue_3.ref)("");
        const activeMenu = (0, vue_3.ref)(false);
        const slots = (0, vue_3.useSlots)();
        const extractVNodeText = (vnode) => {
            if (!vnode)
                return "";
            // Ha közvetlenül szövegként van tárolva
            if (typeof vnode.children === "string") {
                return vnode.children;
            }
            // Ha több gyermek elem van, járjuk be rekurzívan
            if (Array.isArray(vnode.children)) {
                return (vnode.children
                    // @ts-ignore
                    .map((child) => extractVNodeText(child)) // Rekurzívan dolgozzuk fel az összes gyermek elemet
                    .join(" "));
            }
            // Ha a gyermek `default()` egy függvény, akkor hívjuk meg
            if (vnode.children && typeof vnode.children.default === "function") {
                const defaultSlot = vnode.children.default();
                // @ts-ignore
                return defaultSlot.map((child) => extractVNodeText(child)).join(" ");
            }
            return "";
        };
        const filteredOptions = (0, vue_3.computed)(() => {
            if (!slots.default)
                return [];
            return slots
                .default()
                .map((vnode) => {
                // Ha a vnode rendelkezik gyermekekkel, szűrjük a gyermekeket is
                if (vnode.children && Array.isArray(vnode.children)) {
                    const filteredChildren = vnode.children.filter((child) => {
                        // @ts-ignore
                        const childText = extractVNodeText(child).toLowerCase();
                        return childText.includes(searchQuery.value.toLowerCase());
                    });
                    // Ha nincs találat a gyermekek között, akkor ezt a `VNode`-t teljesen elhagyjuk
                    if (filteredChildren.length === 0)
                        return null;
                    // Új `VNode`-t hozunk létre a szűrt gyermekekkel
                    return {
                        ...vnode,
                        children: filteredChildren,
                    };
                }
                // Ha nincs külön gyermek, akkor a közvetlen szöveget vizsgáljuk
                const vnodeText = extractVNodeText(vnode).toLowerCase();
                if (vnodeText.includes(searchQuery.value.toLowerCase())) {
                    return vnode;
                }
                return null; // Ha nincs találat, elhagyjuk az elemet
            })
                .filter(Boolean); // Eltávolítjuk azokat az elemeket, amelyek `null`-t kaptak
        });
        const close = () => {
            activeMenu.value = false;
        };
        const itemSelected = () => {
            close();
            emit("selected");
        };
        /*
        const filteredOptions = computed(() => {
            console.log("aaa");
        });*/
        const toggleMenu = () => {
            if (props.clickable) {
                activeMenu.value = !activeMenu.value;
            }
        };
        __expose({ close });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref: "nav-dropdown",
                class: (0, vue_2.normalizeClass)(["relative nav-dropdown tab", {
                        active: activeMenu.value,
                        'mobile-full-width': __props.mobileFullWidth,
                    }]),
                onClick: _cache[2] || (_cache[2] = ($event) => (toggleMenu()))
            }, [
                (0, vue_2.createElementVNode)("span", _hoisted_1, [
                    (__props.buttonText.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.buttonText), 1)
                        ]))
                        : (0, vue_2.renderSlot)(_ctx.$slots, "buttonText", { key: 1 }),
                    (!__props.hideCaret)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_3))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)(["dropdown-menu rounded-b-md", {
                            '-ml-2': !__props.right,
                            'right-0': __props.right,
                        }])
                }, [
                    (__props.searchable)
                        ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                            key: 0,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            type: "text",
                            placeholder: "Keresés...",
                            class: "w-full p-2 border-b",
                            onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                        }, null, 512)), [
                            [vue_2.vModelText, searchQuery.value]
                        ])
                        : (0, vue_2.createCommentVNode)("", true),
                    (filteredOptions.value.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredOptions.value, (item, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(item), (0, vue_2.mergeProps)({ key: index }, { itemSelected: itemSelected }), null, 16));
                            }), 128))
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, "Nincs találat"))
                ], 2)
            ], 2));
        };
    }
});
